import Vue from 'vue'
import App from './App.vue'

import ElementUI from 'element-ui'  //引入element-ui库
import Vant from 'vant';
import 'vant/lib/index.css';

import VForm from 'vform-builds'  //引入VForm库
import router from './router'

import 'element-ui/lib/theme-chalk/index.css'  //引入element-ui样式
import 'vform-builds/dist/VFormDesigner.css'  //引入VForm样式

import axios from './axios'
Vue.prototype.$axios = axios

Vue.config.productionTip = false

Vue.use(ElementUI)  //全局注册element-ui
Vue.use(Vant);
Vue.use(VForm)  //全局注册VForm(同时注册了v-form-designer和v-form-render组件)

new Vue({
    router,
  render: h => h(App),
}).$mount('#app')